/*global $:false */

import { format as formatNumber } from '../fields/recordm.fields.number.js';
import { sprintf } from 'sprintf-js';

import tmpl_entities from '../templates/search-unified-entities.dot';
import tmpl_entities_btns from '../templates/search-unified-entities-btns.dot';
import tmpl_entity from '../templates/search-unified-entity.dot';
import tmpl_more_results from '../templates/search-unified-more-results.dot';
import tmpl_no_results from '../templates/search-unified-no-results.dot';
import tmpl_total_results from '../templates/search-unified-total-results.dot';

// $container: the jquery HTML wrapper for the enclosing element
//
// confs
//      * `rowsPerPage` : The size of the result (page size)
//
// callbacks:
//      * moreRecordsClick: called when the user asks for more search results
//      * executeInstanceAction(actionKey, instanceKey, instanceId): Execute the specific action on the instance result
//
var UnifiedSearchResultV = function(core, $container, confs, callbacks) {

    var _$results = $(".js-results", $container),
        _$sideNav = $(".js-side-nav", $container),
        _$bottomNav = $(".js-bottom-nav", $container),
        _$messageContainer = $(".js-message", $container),
        _pageSize = confs.rowsPerPage,
        _totalResults;

    var _showData = function(entries) {

        $container.removeClass("hidden")
            .addClass("search-done");

        var $itemsList;

        if (entries.length > 0) {
            $itemsList = $(tmpl_entities({ entries: entries, entryTemplate: tmpl_entity}));

        } else {
            $itemsList = $(tmpl_no_results());
        }

        core.translate("recordm.search", $itemsList);

        // Remove all .js-entity-item from the template and add them to the DOM element container.
        _$results.append($('.js-entity-item', $itemsList).detach());

        if (entries.length < _totalResults) {
            _addMoreRecordRow(_pageSize);
        }
    };

    var _updateNav = function($nav, totals) {
        //clear previous results
        $nav.html(tmpl_entities_btns({
           definitionsTotals: totals.map((total) => ({
              id: total.id,
              uri: total.uri,
              name: total.name,
              total: formatNumber(total.total, false, 0, core.getLocale())
           }))
        })).removeClass("hidden");
    };

    var _addMoreRecordRow = function(count) {
        var _moreLink = $(tmpl_more_results({
           message: sprintf(core.translateString("recordm.search", "search.next-result"), count)
        }));

        $('.more-records-row', _$results).remove();
        _$results.append(_moreLink);
    };

    var _addListenerToMoreRecordsRequest = function() {
        _$results.on('click', '.js-more-records', function(e) {
            e.preventDefault();
            callbacks.moreRecordsClick();
        });
    };

    var _addListenerForInstanceActions = function() {
        _$results.on('click', '.js-action', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            var $action = $(this);

            if (callbacks.executeInstanceAction) {
                callbacks.executeInstanceAction(
                    $action.data("action-key"),
                    $action.data("instancekey"),
                    $action.data("instanceid")
                );
            }
        });
    };

    var _showInStartMode = function() {
        _totalResults = undefined;
        $container.removeClass("search-done");
        _clearData();
    };

    var _clearData = function() {
        _$results.html('');
        _$sideNav.html('');
        _$bottomNav.html('');
    };

    var _init = function() {
        _addListenerToMoreRecordsRequest();
        _addListenerForInstanceActions();

        _showInStartMode();
    };

    return {
        init: _init,
        clearData: _clearData,
        showData: _showData,
        showInStartMode: _showInStartMode,
        showContainer: function() {
            $container.removeClass("hidden");
        },
        showSearchInProgressMode: function() {
            $container.removeClass("hidden")
                .addClass("search-done");
        },
        setTotalRecords: function(domainM, total) {
            var $newMessage = $(tmpl_total_results({
                totalResults: formatNumber(total, false, 0, core.getLocale()),
                domainM: domainM
            }));

            core.translate("recordm.search", $newMessage);

            _$messageContainer.replaceWith($newMessage);
        },
        updateSideNav: function(total, totalsPerType) {
            _totalResults = total;
            _updateNav(_$sideNav, totalsPerType);
        },
        updateBottomNav: function(total, totalsPerType) {
            _totalResults = total;
            _updateNav(_$bottomNav, totalsPerType);
        }
    };
};

export default UnifiedSearchResultV;
